<template>
  <div>
    <div style="padding:15px">
      <div style="padding-bottom:10px">
        <el-button type="primary" size="mini" style="margin:5px 0 0 5px;" @click="upVisible = true">模板上传</el-button>
      </div>
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane v-for="(v, k) in tplTypes" :key="k" :label="k" :name="k"></el-tab-pane>
      </el-tabs>
      <el-table :data="tableData" size="mini" border style="width: 100%">
        <el-table-column label="文件名" show-overflow-tooltip min-width="250">
          <template slot-scope="scope">
            <el-popover placement="right" width="100">
              <el-button
                size="mini"
                type="text"
                @click="
                  preview({
                    fileId: scope.row.fileId,
                    src: scope.row.src,
                    md5: scope.row.md5,
                    originalname: scope.row['文件名'],
                  })
                "
                >预览</el-button
              >
              <el-button
                v-if="userInservice"
                size="mini"
                type="text"
                @click="
                  download({
                    fileId: scope.row.fileId,
                    src: scope.row.src,
                    md5: scope.row.md5,
                    originalname: scope.row['文件名'],
                  })
                "
                >下载</el-button
              >
              <el-button v-if="userInservice" slot="reference" size="mini" type="text">{{
                scope.row['文件名']
              }}</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="模板类型" label="模板类型" width="80"></el-table-column>
        <el-table-column prop="类别" label="类别" width="120"></el-table-column>
        <el-table-column prop="名称" label="名称" show-overflow-tooltip min-width="250"></el-table-column>
        <el-table-column prop="描述" label="描述" show-overflow-tooltip min-width="250"></el-table-column>
        <el-table-column prop="上传人" label="上传人" width="100"></el-table-column>
        <el-table-column prop="上传时间" label="上传时间" width="100"></el-table-column>
      </el-table>
    </div>

    <el-dialog title="模板上传" :visible.sync="upVisible" :close-on-click-modal="false" @close="handleClose">
      <el-form ref="tplForm" :model="tplForm" label-width="80px">
        <el-form-item label="模板类型*">
          <el-select v-model="tplForm['模板类型']" filterable size="mini" placeholder="选择">
            <el-option v-for="(v, k) in tplTypes" :key="k" :label="k" :value="k"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类别">
          <el-select v-model="tplForm['类别']" size="mini" filterable allow-create placeholder="选择或输入">
            <el-option v-for="(t, k) in tplTypes[tplForm.模板类型]" :key="k" :label="t" :value="t"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称"> <el-input v-model="tplForm['名称']" size="mini" /> </el-form-item>
        <el-form-item label="描述"> <el-input v-model="tplForm['描述']" size="mini" /> </el-form-item>
        <el-form-item label="文件*">
          <span>{{ tplForm['文件名'] }}</span>
          <el-button v-show="!tplForm['文件名']" type="primary" size="mini" @click="showUpload">上传</el-button>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <div v-show="showBtn">
          <el-button size="mini" @click="handleClose">取消</el-button>
          <el-button size="mini" type="primary" @click="handleSave">确认</el-button>
        </div>
      </div>
    </el-dialog>
    <UploadDialog ref="upload" :on-success="handleUpload" type="templateFile" label="templateFile" />
  </div>
</template>
<script>
import { download, preview } from '../../project/src/constant/utils'

const dateFormat = require('dateformat')

export default {
  data() {
    return {
      tplTypes: {
        客户: ['客户BD', '客户对接', '汇报', '收款'],
        模板: ['推荐报告', '推荐邮件正文', '面试邮件', '面试反馈', '客户经理邮件签名'],
        公司制度: [],
        经典案例: [
          '客户BD',
          '客户对接',
          '汇报',
          '收款',
          '推荐报告',
          '推荐邮件正文',
          '面试邮件',
          '面试反馈',
          '客户经理邮件签名',
        ],
        素材库: [
          '客户BD',
          '客户对接',
          '汇报',
          '收款',
          '推荐报告',
          '推荐邮件正文',
          '面试邮件',
          '面试反馈',
          '客户经理邮件签名',
        ],
        系统操作: [],
      },
      tplForm: {
        模板类型: '',
        类别: '',
        名称: '',
        描述: '',
        fileId: '',
        md5: '',
        文件名: '',
        src: '',
        上传人: app.user.account,
        上传时间: dateFormat(new Date(), 'yyyy-mm-dd'),
      },
      activeTab: '客户',
      upVisible: false,
      fileData: [],
      downloadLoading: false,
      // 是否在职，在职true
      userInservice: true,
    }
  },
  computed: {
    showBtn: function() {
      return this.tplForm['模板类型'] && this.tplForm['文件名']
    },
    tableData: function() {
      return this.fileData.filter(tpl => tpl['模板类型'] === this.activeTab)
    },
    download() {
      return download
    },
    preview() {
      return preview
    },
  },
  mounted() {
    this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
    this.loadData()
  },
  methods: {
    loadData: async function() {
      const res = await app.service('misc').listTemplateFiles()
      if (res.status === 'success') {
        this.fileData = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    showUpload: function() {
      this.$refs.upload.visible(true)
    },
    handleUpload: function(response, file, fileList) {
      if (response.length > 0) {
        const f = response[0]
        this.tplForm.fileId = f._id
        this.tplForm['文件名'] = f.originalname
        this.tplForm.src = f.src
        this.tplForm.md5 = f.md5
        this.tplForm['上传人'] = app.user.account
        this.tplForm['上传时间'] = dateFormat(new Date(), 'yyyy-mm-dd')
      }
      this.$refs.upload.visible()
    },
    handleSave: async function() {
      const res = await app.service('misc').addTemplateFile(this.tplForm)
      if (res.status === 'success') {
        this.$message.success('成功')
        this.loadData()
        this.handleClose()
      } else {
        this.$message.error(res.msg)
      }
    },
    handleClose: function() {
      this.tplForm = {
        模板类型: '',
        类别: '',
        名称: '',
        描述: '',
        fileId: '',
        md5: '',
        文件名: '',
        src: '',
        上传人: app.user.account,
        上传时间: dateFormat(new Date(), 'yyyy-mm-dd'),
      }
      this.upVisible = false
    },
  },
}
</script>
